export default "__VITE_ASSET__BWKZjw_x__"